export default __webpack_public_path__ + "static/media/Background_00084.1a100ab6.png";